import * as React from "react";

const SvgPhone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.2 18.2"
    style={{
      enableBackground: "new 0 0 18.2 18.2",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill="currentColor"
      id="star_00000097475351879316446410000011943004511693874350_"
      className="st2"
      d="M9.1,14.9l-4.9,2.6c-0.2,0.1-0.4,0-0.4-0.1
	c0-0.1,0-0.1,0-0.2l0.9-5.5l-4-3.9c-0.1-0.1-0.1-0.3,0-0.5c0-0.1,0.1-0.1,0.2-0.1l5.5-0.8l2.5-5c0.1-0.2,0.3-0.2,0.4-0.1
	c0.1,0,0.1,0.1,0.1,0.1l2.5,5l5.5,0.8c0.2,0,0.3,0.2,0.3,0.4c0,0.1,0,0.1-0.1,0.2l-4,3.9l0.9,5.5c0,0.2-0.1,0.3-0.3,0.4
	c-0.1,0-0.1,0-0.2,0L9.1,14.9z"
    />
  </svg>
);

export default SvgPhone;
